import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const kimeNoKataCriteriaI18n: CriterionLocaleBundle = {
  ja: {
    'kime-gen-start-pos': {
      text: '取が開始位置を決め、受が正しい間合いを取る。',
    },
    'kime-gen-weapons-place': {
      text: '武器を正しく置き、取り上げる方法。',
    },
    'kime-gen-weapons-bow': {
      text: '取と受が互いに礼をする前に、受は右側の畳にまず大刀、次に短刀を置く。脚と平行にし、刃を自分に向け、短刀の柄を大刀の鍔にそろえる。取り上げはまず短刀、次に大刀。',
    },
    'kime-gen-weapons-walk': {
      text: '受は立って向きを変え、約 1.8 m 歩き、座って武器を体の前に垂直に持ち、その後、畳の線と平行に置く（短刀は内側、両方の刃は自分に向ける）。',
    },
    'kime-gen-weapons-end': {
      text: '形の終わりに、受はまず短刀、次に大刀を取り上げ、右側に持つ。',
    },
    'kime-gen-attack-distance': {
      text: '攻撃の間合い。',
    },
    'kime-gen-idori-toes': {
      text: '居取：両手取を除き、攻撃時には足の爪先を立てる。',
    },
    'kime-gen-arm-lock-steps': {
      text: '取が腕の関節技を施す際の移動：右足・左足・右足／左足・右足・左足。',
    },
    'kime-gen-weapons-general': {
      text: '武器の全般的な扱い。',
    },
    'kime-gen-weapons-technique': {
      text: '各技での武器の扱い。',
    },
    'kime-gen-direction': {
      text: '技を行う方向。',
    },
    'kime-gen-arm-lock-look': {
      text: '取が腕の関節技を施す際に、まっすぐ前を見る。',
    },
    'kime-gen-kiai': {
      text: '気合（kiai）。',
      hint: '不要な場合は小（Small）；発しない場合は中（Medium）',
    },
    'kime-gen-submission': {
      text: '参ったの合図として二回たたく。',
    },
    'kime-idori-ryote-dori-1': {
      text: '間合い：最初は約 90 cm。取と受は膝を滑らせて前進し、膝詰（hiza-zume）の間合い（二拳分）になる。',
    },
    'kime-idori-ryote-dori-2': {
      text: '受は爪先を立てずに取の両手首を握り、気合を発する。',
    },
    'kime-idori-ryote-dori-3': {
      text: '取は爪先を立て、両膝をそろえて受の水月を蹴り、気合を発する。その後、右膝を畳につき、左膝を立てる。',
    },
    'kime-idori-ryote-dori-4': {
      text: '取は受の左手首を取って左へ回り、左腕を斜め前に引いて自分の右腋下に挟み、腕挫腋固（Ude-hishigi-waki-gatame）を施す。',
    },
    'kime-idori-ryote-dori-5': {
      text: '受は膝をついたまま、取の脚を二回たたいて参ったの合図をする。',
    },
    'kime-idori-tsukkake-1': {
      text: '間合い：膝詰。',
    },
    'kime-idori-tsukkake-2': {
      text: '受は爪先を立て、甲を下にした右拳で取の水月を突こうとし、気合を発する。',
    },
    'kime-idori-tsukkake-3': {
      text: '取は爪先を立て、左膝を軸に右へ 90° 回り、左手で突きをそらし、甲を下にした右拳で受の眉間に当身を加え、気合を発する。',
    },
    'kime-idori-tsukkake-4': {
      text: '取は右手首を自分の右腰へ引き、左手で襟を握り、斜め前に二歩進んで腕挫腹固（Ude-hishigi-hara-gatame）を施し、受の首を制する。',
    },
    'kime-idori-tsukkake-5': {
      text: '受は膝をついたまま、畳を二回たたいて参ったの合図をする。',
    },
    'kime-idori-suri-age-1': {
      text: '間合い：膝詰。',
    },
    'kime-idori-suri-age-2': {
      text: '受は爪先を立て、手のひらで取の額を突き上げようとし、気合を発する。',
    },
    'kime-idori-suri-age-3': {
      text: '取は防いでから手首を握り、左手を腋下に入れ、水月を蹴って気合を発し、続いて回転し、受の腕をねじってうつ伏せにする。',
    },
    'kime-idori-suri-age-4': {
      text: '取は腕を前方へ押し、膝で左・右の順に二歩前進し、左膝を肘の後ろに置き、腕挫膝固（ude-hishigi-hiza-gatame）を施す。',
    },
    'kime-idori-suri-age-5': {
      text: '受は畳を二回たたいて参ったの合図をする。',
    },
    'kime-idori-yoko-uchi-1': {
      text: '間合い：膝詰。',
    },
    'kime-idori-yoko-uchi-2': {
      text: '受は爪先を立て、右拳で取の左こめかみを打とうとし、気合を発する。',
    },
    'kime-idori-yoko-uchi-3': {
      text: '取は受の右腕の下に潜り、右足を踏み出し、肩固（Kata-gatame）のように受を制する。',
    },
    'kime-idori-yoko-uchi-4': {
      text: '取は左足を踏み出しながら受を後方に押し倒して仰向けにし、肘を顔へ押しつけ、肘により水月を打ち、気合を発する。',
    },
    'kime-idori-yoko-uchi-5': {
      text: '受は取に向かって遠間（toma、約 1.2 m）に座り、立ち上がって取の右側を回り、取の後ろ一歩の位置に座る。',
    },
    'kime-idori-ushiro-dori-1': {
      text: '間合い：最初は取の後方一歩。受は膝を滑らせて取の後方約 20 cm まで進む。',
    },
    'kime-idori-ushiro-dori-2': {
      text: '受は爪先を立て、右足を踏み出して取の両上腕を抱え、気合を発する。',
    },
    'kime-idori-ushiro-dori-3': {
      text: '取は両腕を上げて抱えを解き、袖を握り、右脚を受の両脚の間へ後方に滑らせ、巻込（Makikomi）のように左へ転がる。',
    },
    'kime-idori-ushiro-dori-4': {
      text: '後袈裟固（Ushiro-kesa-gatame）のように受を制しながら、左拳で股間を打ち、気合を発する。',
    },
    'kime-idori-ushiro-dori-5': {
      text: '受は取の後ろ一歩に戻り、立ち上がって取の右側を回り、遠間（約 1.2 m）で取に向かって座る。',
    },
    'kime-idori-tsukkomi-1': {
      text: '受は右手を上、左手を下にして短刀を取り、刃を上に向けて上衣の中に入れる。間合い：最初は約 90 cm、膝を滑らせて約 45 cm まで進む。',
    },
    'kime-idori-tsukkomi-2': {
      text: '受は短刀を抜き、爪先を立て、左足を前に出して取の腹を刺そうとし、気合を発する。',
    },
    'kime-idori-tsukkomi-3': {
      text: '取は右へ 90° 回り、突きをそらし、当身を加え、手首を腰へ引き、襟を握り、斜め前に二歩進んで腕挫腹固を施し、首を制する。',
    },
    'kime-idori-tsukkomi-4': {
      text: '受は膝をついたまま畳を二回たたき、座った姿勢に戻る際に短刀を上衣の中に戻す。',
    },
    'kime-idori-kirikomi-1': {
      text: '間合い：約 45 cm。',
    },
    'kime-idori-kirikomi-2': {
      text: '受は短刀を小刀の代用として帯に差し、爪先を立て、右足を前に出し、額の上部を切ろうとし、気合を発する。',
    },
    'kime-idori-kirikomi-3': {
      text: '取は両手で手首を捕らえ、左膝を軸に回り、腕を腋下に挟んで腕挫腋固を施す。',
    },
    'kime-idori-kirikomi-4': {
      text: '受は取の脚を二回たたき、遠間（約 1.2 m）に座り、小刀を短刀として上衣の中に戻す。',
    },
    'kime-idori-yoko-tsuki-1': {
      text: '受は取の右側に座り、膝を滑らせて少し前進する。間合い：側方約 20 cm。',
    },
    'kime-idori-yoko-tsuki-2': {
      text: '受は短刀を抜き、爪先を立て、左足を前に踏み出し、刃を上に向けて取の右脇を刺そうとし、気合を発する。',
    },
    'kime-idori-yoko-tsuki-3': {
      text: '取は右へ 180° 回り、突きをそらし、当身を加え、手首と襟を握り、斜め前に二歩進んで腕挫腹固を施し、首を制する。',
    },
    'kime-idori-yoko-tsuki-4': {
      text: '受は畳を二回たたき、両者は並んで座り、受は短刀を上衣に戻して遠間へ歩き、短刀を畳の元の位置に戻す。',
    },
    'kime-tachiai-ryote-dori-1': {
      text: '受の間合い：一歩、約 40 cm。',
    },
    'kime-tachiai-ryote-dori-2': {
      text: '受は右足を半歩進めて取の両手首を握り、気合を発する。',
    },
    'kime-tachiai-ryote-dori-3': {
      text: '取は両腕を後方へ引いて崩し、股間を蹴って気合を発し、足は直ちに下ろす。',
    },
    'kime-tachiai-ryote-dori-4': {
      text: '取は左腕を斜め外側へ引き、立ち姿勢で腕挫腋固を施す。',
    },
    'kime-tachiai-ryote-dori-5': {
      text: '受は取の脚を二回たたき、両者は開始位置に戻り、受は遠間（約 1.2 m）で取に向かい合う。',
    },
    'kime-tachiai-sode-tori-1': {
      text: '受は取の右側を回り（取は少し後退）、後方から左袖を握り、右足・左足・右足の順に前進させる。',
    },
    'kime-tachiai-sode-tori-2': {
      text: '三歩目に取は右へ崩し、左足の小指側で右膝を蹴って気合を発し、左へ 180° 回る。',
    },
    'kime-tachiai-sode-tori-3': {
      text: '取は右袖と左襟を握り、大外刈（O-soto-gari）で投げる。',
    },
    'kime-tachiai-tsukkake-1': {
      text: '両者は三歩、約 1.8 m の間合いで向かい合って立つ。',
    },
    'kime-tachiai-tsukkake-2': {
      text: '受は左足でフェイントをかけ、右足を踏み込んで甲を下にした右拳で眉間（uto）を突こうとし、気合を発する。',
    },
    'kime-tachiai-tsukkake-3': {
      text: '取は体捌き（tai-sabaki）で右へ 90° 回り、前腕の手首近くを握り、前下方へ引く。',
    },
    'kime-tachiai-tsukkake-4': {
      text: '取は受の後ろへ進み、裸絞（Hadaka-jime）のように左肩で両手を組み、受が引き戻す際に絞める。',
    },
    'kime-tachiai-tsukkake-5': {
      text: '受は右上腕を引き下げて防御し、右足で畳を二回たたいて参ったの合図をする。',
    },
    'kime-tachiai-tsuki-age-1': {
      text: '約一歩の間合い。',
    },
    'kime-tachiai-tsuki-age-2': {
      text: '受は右足を踏み出し、顎を突き上げようとし、気合を発する。',
    },
    'kime-tachiai-tsuki-age-3': {
      text: '取は後ろに反り、両手で手首を取って上方、斜め前方へ引き、立ち姿勢で腕挫腋固を施す。',
    },
    'kime-tachiai-tsuki-age-4': {
      text: '受は過度に前屈せず、取の脚を二回たたいて参ったの合図をする。',
    },
    'kime-tachiai-suri-age-1': {
      text: '約一歩の間合い。',
    },
    'kime-tachiai-suri-age-2': {
      text: '受は右足を踏み出し、手のひらで取の額を打とうとし、気合を発する。',
    },
    'kime-tachiai-suri-age-3': {
      text: '取は後ろへ反り、左前腕で肘のところを払ってそらし、甲を下にした右拳で腹を突いて気合を発する。',
    },
    'kime-tachiai-suri-age-4': {
      text: '直ちに左浮腰（Uki-goshi）で投げる。',
    },
    'kime-tachiai-yoko-uchi-1': {
      text: '約一歩の間合い。',
    },
    'kime-tachiai-yoko-uchi-2': {
      text: '受は右足を踏み出し、右拳で取の左こめかみを打とうとし、気合を発する。',
    },
    'kime-tachiai-yoko-uchi-3': {
      text: '取は左足を踏み込んで潜り、胸を押し、襟を握り、右足・左足の順に受の後ろへ進む。',
    },
    'kime-tachiai-yoko-uchi-4': {
      text: '送襟絞（Okuri-eri-jime）：額を後頭部に当て、左足を後退させて腰を下げる。',
    },
    'kime-tachiai-yoko-uchi-5': {
      text: '受は左上腕を引き下げて防御し、右足で畳を二回打って参ったの合図をする。',
    },
    'kime-tachiai-ke-age-1': {
      text: '間合い：一歩。',
    },
    'kime-tachiai-ke-age-2': {
      text: '受は左足を小さく一歩進め、股間を蹴ろうとし、気合を発する。',
    },
    'kime-tachiai-ke-age-3': {
      text: '取は右足を引き、体捌きで右へ 90° 回り、足首を捕らえ、足を左へ引き、腰をひねって股間を蹴り、気合を発する。',
    },
    'kime-tachiai-ke-age-4': {
      text: '両者は遠間（約 1.2 m）で向かい合う。',
    },
    'kime-tachiai-ushiro-dori-1': {
      text: '受は取の右側を回り、真後ろ約 90 cm の位置に立つ。その間、取は後退する。',
    },
    'kime-tachiai-ushiro-dori-2': {
      text: '取は左足・右足・左足の順に三歩前進し、三歩目で受は両上腕を抱える。',
    },
    'kime-tachiai-ushiro-dori-3': {
      text: '取は両肘を外へ開き、両手で右袖の上部を握り、背負投（Seoi-nage）で投げる。',
    },
    'kime-tachiai-ushiro-dori-4': {
      text: '取は右膝を畳につき、左膝を立て、手刀（Te-gatana）で眉間を打って気合を発する。受は遠間（約 1.2 m）に位置する。',
    },
    'kime-tachiai-tsukkomi-1': {
      text: '受は右手を上、左手を下にして短刀を取り、刃を上にして上衣の中に入れる。間合い：約 90 cm。',
    },
    'kime-tachiai-tsukkomi-2': {
      text: '受は短刀を抜き、左足を踏み出して水月を刺そうとし、気合を発する。',
    },
    'kime-tachiai-tsukkomi-3': {
      text: '取は体捌きで右へ 90° 回り、突きをそらし、当身を加え、手首を腰へ引き、襟を握り、斜め前に二歩進んで腕挫腹固を施す。',
    },
    'kime-tachiai-tsukkomi-4': {
      text: '受は過度に前屈せず、取の脚を二回たたき、短刀を上衣の中に戻す。',
    },
    'kime-tachiai-kirikomi-1': {
      text: '受は約 90 cm の位置で短刀を小刀の代用として帯に差し、右足を踏み出して額に切り込み、気合を発する。',
    },
    'kime-tachiai-kirikomi-2': {
      text: '取は両手で手首を握り、腕を腋下に挟み、斜め後方へ移動しながら腕挫腋固を施す。',
    },
    'kime-tachiai-kirikomi-3': {
      text: '受は過度に前屈せず、取の脚を二回たたき、遠間（約 1.2 m）へ戻り、小刀を帯に戻してから短刀として上衣の中に戻す。',
    },
    'kime-tachiai-nuki-kake-1': {
      text: '受は短刀を畳に戻し、大刀を取って刃を上にして左側の帯に差す。',
    },
    'kime-tachiai-nuki-kake-2': {
      text: '遠間で受は右足を踏み出し、大刀を抜こうとする。',
    },
    'kime-tachiai-nuki-kake-3': {
      text: '取は右足を受の右足の近くへ踏み出し、右手首を押さえて抜刀を止める。',
    },
    'kime-tachiai-nuki-kake-4': {
      text: '取は左足を受の後ろへ回し、襟を握り、斜め後方へ退いて片羽絞（Kataha-jime）を施す。',
    },
    'kime-tachiai-nuki-kake-5': {
      text: '受は右足で畳を二回打って参ったの合図をする。',
    },
    'kime-tachiai-kiri-oroshi-1': {
      text: '取は受の開始位置から約 2.7 m の位置にいる。',
    },
    'kime-tachiai-kiri-oroshi-2': {
      text: '受は切先を目に向けてゆっくり抜き、正眼（Seigan）の構えを取り、継ぎ足で前進する。取は右足から一歩後退する。',
    },
    'kime-tachiai-kiri-oroshi-3': {
      text: '受は上段（Jodan）の構えを取り、頭頂を切ろうとして気合を発する。切り下ろす前に大刀を頭上に立てる。',
    },
    'kime-tachiai-kiri-oroshi-4': {
      text: '取は左足を踏み出し、体捌きで右へ 90° 回ってそらし、手首を腰へ引き、襟を握り、右・左・右の順に斜め前に進んで腕挫腹固を施す。',
    },
    'kime-tachiai-kiri-oroshi-5': {
      text: '受は過度に前屈せず、取の脚を二回たたく。大刀を納めて戻し、取は元の位置へ後退する。',
    },
  },
  'zh-Hant': {
    'kime-gen-start-pos': {
      text: '取決定起始位置，受採取正確距離。',
    },
    'kime-gen-weapons-place': {
      text: '正確放置及收取武器的方式。',
    },
    'kime-gen-weapons-bow': {
      text: '取與受互相行禮前，受先放刀、再放短刀，置於自己右方的榻榻米上，與腿平行，刃朝向自己；收取順序為先短刀、後刀。',
    },
    'kime-gen-weapons-walk': {
      text: '受站起，轉身，步行約 1.8 米，坐下，將武器垂直持於身前，再放在榻榻米上與線平行（短刀在內側，刃朝向自己）。',
    },
    'kime-gen-weapons-end': {
      text: '形結束時，受先取短刀、再取刀，持於右側。',
    },
    'kime-gen-attack-distance': {
      text: '攻擊距離。',
    },
    'kime-gen-idori-toes': {
      text: '居取：攻擊時須豎起腳趾，以腳趾支撐；Ryote-dori 除外。',
    },
    'kime-gen-arm-lock-steps': {
      text: '取施手臂關節技時的移動順序：右腳、左腳、右腳／左腳、右腳、左腳。',
    },
    'kime-gen-weapons-general': {
      text: '武器的一般使用。',
    },
    'kime-gen-weapons-technique': {
      text: '各項技術中的武器使用。',
    },
    'kime-gen-direction': {
      text: '施技方向。',
    },
    'kime-gen-arm-lock-look': {
      text: '取施手臂關節技時直視前方。',
    },
    'kime-gen-kiai': {
      text: '氣合（kiai）。',
      hint: '不必要時發出：輕微（Small）；應有而未發出：中等（Medium）',
    },
    'kime-gen-submission': {
      text: '認輸，拍擊兩次。',
    },
    'kime-idori-ryote-dori-1': {
      text: '距離：起初約 90 厘米，取與受滑動膝部向前，移至膝詰（hiza-zume）距離，即兩拳間隔。',
    },
    'kime-idori-ryote-dori-2': {
      text: '受不豎起腳趾，握取的雙手腕，發出氣合。',
    },
    'kime-idori-ryote-dori-3': {
      text: '取豎起腳趾，雙膝併攏，踢受的心窩並發出氣合；然後右膝著地、左膝立起。',
    },
    'kime-idori-ryote-dori-4': {
      text: '取握受的左手腕，向左轉，將左臂斜向前拉，夾於右腋下，以腕挫腋固（Ude-hishigi-waki-gatame）施技。',
    },
    'kime-idori-ryote-dori-5': {
      text: '受應保持跪姿，拍取的腿兩次表示認輸。',
    },
    'kime-idori-tsukkake-1': {
      text: '距離：膝詰。',
    },
    'kime-idori-tsukkake-2': {
      text: '受豎起腳趾，嘗試以右手反拳打取的心窩，發出氣合。',
    },
    'kime-idori-tsukkake-3': {
      text: '取豎起腳趾，以左膝為軸向右轉 90°，以左手撥開攻擊，再以右手反拳打受的眉間，發出氣合。',
    },
    'kime-idori-tsukkake-4': {
      text: '取握右手腕拉至右髖，左手握襟，斜向前移兩步，以腕挫腹固（Ude-hishigi-hara-gatame）施技，同時控制頸部。',
    },
    'kime-idori-tsukkake-5': {
      text: '受應保持跪姿，拍榻榻米兩次表示認輸。',
    },
    'kime-idori-suri-age-1': {
      text: '距離：膝詰。',
    },
    'kime-idori-suri-age-2': {
      text: '受豎起腳趾，嘗試以右掌突推取的前額，發出氣合。',
    },
    'kime-idori-suri-age-3': {
      text: '取防守後握手腕，左手置於腋下，踢心窩並發出氣合，隨後轉身扭轉手臂使其俯伏。',
    },
    'kime-idori-suri-age-4': {
      text: '取將手臂向前推，以膝部依左、右順序前進兩步，左膝置於肘後，以腕挫膝固（ude-hishigi-hiza-gatame）施技。',
    },
    'kime-idori-suri-age-5': {
      text: '受拍榻榻米兩次表示認輸。',
    },
    'kime-idori-yoko-uchi-1': {
      text: '距離：膝詰。',
    },
    'kime-idori-yoko-uchi-2': {
      text: '受豎起腳趾，嘗試以右拳打取的左太陽穴，發出氣合。',
    },
    'kime-idori-yoko-uchi-3': {
      text: '取從右臂下潛避，右腳向前踏出，以類似肩固（Kata-gatame）的方式控制受。',
    },
    'kime-idori-yoko-uchi-4': {
      text: '取左腳向前踏出，將受向後推倒至仰臥，將肘壓向臉部，以肘擊心窩，發出氣合。',
    },
    'kime-idori-yoko-uchi-5': {
      text: '受在遠間（toma，約 1.2 米）面向取坐下，再站起，繞過取的右側，於取後方一步的位置坐下。',
    },
    'kime-idori-ushiro-dori-1': {
      text: '距離：起初在取後方一步，受滑動膝部前進至取後方約 20 厘米。',
    },
    'kime-idori-ushiro-dori-2': {
      text: '受豎起腳趾，右腳踏前，環抱取的上臂，發出氣合。',
    },
    'kime-idori-ushiro-dori-3': {
      text: '取雙臂向外抬起，握袖，右腿向後滑入受的雙腿之間，如施卷込（Makikomi）般向左滾動。',
    },
    'kime-idori-ushiro-dori-4': {
      text: '以類似後袈裟固（Ushiro-kesa-gatame）的方式控制受，同時以左拳打腹股溝，發出氣合。',
    },
    'kime-idori-ushiro-dori-5': {
      text: '受回到取後方一步，再站起，繞過取的右側，在遠間（約 1.2 米）面向取坐下。',
    },
    'kime-idori-tsukkomi-1': {
      text: '受收取短刀，右手在上、左手在下，刃朝上放入上衣內。距離：起初約 90 厘米，滑動膝部前進至約 45 厘米。',
    },
    'kime-idori-tsukkomi-2': {
      text: '受拔出短刀，豎起腳趾，左腳向前，嘗試刺取的腹部，發出氣合。',
    },
    'kime-idori-tsukkomi-3': {
      text: '取向右轉 90°，撥開攻擊，施當身，將手腕拉至髖部，握襟，斜向前移兩步，施腕挫腹固並控制頸部。',
    },
    'kime-idori-tsukkomi-4': {
      text: '受應保持跪姿，拍榻榻米兩次；回到坐姿時將短刀放回上衣內。',
    },
    'kime-idori-kirikomi-1': {
      text: '距離：約 45 厘米。',
    },
    'kime-idori-kirikomi-2': {
      text: '受將短刀移至腰帶作為短劍，豎起腳趾，右腳向前，嘗試劈向前額頂部，發出氣合。',
    },
    'kime-idori-kirikomi-3': {
      text: '取以雙手接住手腕，以左膝為軸轉身，將手臂夾於腋下，施腕挫腋固。',
    },
    'kime-idori-kirikomi-4': {
      text: '受拍取的腿兩次；在遠間（約 1.2 米）坐下，將短劍作為短刀放回上衣內。',
    },
    'kime-idori-yoko-tsuki-1': {
      text: '受坐於取的右側，滑動膝部稍向前移。距離：側方約 20 厘米。',
    },
    'kime-idori-yoko-tsuki-2': {
      text: '受拔出短刀，豎起腳趾，左腳向前踏出，嘗試刺取的右側，刃朝上，發出氣合。',
    },
    'kime-idori-yoko-tsuki-3': {
      text: '取向右轉 180°，撥開攻擊，施當身，握手腕與襟，斜向前移兩步，施腕挫腹固並控制頸部。',
    },
    'kime-idori-yoko-tsuki-4': {
      text: '受拍榻榻米兩次；雙方回到並坐；受將短刀放回上衣，走回遠間，再將短刀放回榻榻米原位。',
    },
    'kime-tachiai-ryote-dori-1': {
      text: '受的距離：一步，約 40 厘米。',
    },
    'kime-tachiai-ryote-dori-2': {
      text: '受右腳前進半步，握取的雙手腕，發出氣合。',
    },
    'kime-tachiai-ryote-dori-3': {
      text: '取雙臂向後拉，使受向前失去平衡；踢腹股溝並發出氣合，隨即將腳放回地面。',
    },
    'kime-tachiai-ryote-dori-4': {
      text: '取將左臂斜向外拉，以站姿施腕挫腋固。',
    },
    'kime-tachiai-ryote-dori-5': {
      text: '受拍取的腿兩次；雙方回到起始位置，受在遠間（約 1.2 米）面向取。',
    },
    'kime-tachiai-sode-tori-1': {
      text: '受繞過取的右側（取稍向後退），從後方握左袖，迫使取依右腳、左腳、右腳順序前進。',
    },
    'kime-tachiai-sode-tori-2': {
      text: '第三步時，取向右崩，以左腳小趾側踢右膝，發出氣合，向左轉 180°。',
    },
    'kime-tachiai-sode-tori-3': {
      text: '取握右袖及左襟，以大外刈（O-soto-gari）摔出受。',
    },
    'kime-tachiai-tsukkake-1': {
      text: '取與受相對站立，相距三步，約 1.8 米。',
    },
    'kime-tachiai-tsukkake-2': {
      text: '受左腳作佯攻，再以右腳突進，嘗試以右手反拳打眉間（uto），發出氣合。',
    },
    'kime-tachiai-tsukkake-3': {
      text: '取運用體捌（tai-sabaki）向右轉 90°，握前臂近手腕處，向前下方拉。',
    },
    'kime-tachiai-tsukkake-4': {
      text: '取踏至受後方，如裸絞（Hadaka-jime）般在左肩處合手，於受向後拉時施絞。',
    },
    'kime-tachiai-tsukkake-5': {
      text: '受向下拉右上臂防守，以右腳拍榻榻米兩次表示認輸。',
    },
    'kime-tachiai-tsuki-age-1': {
      text: '相距約一步。',
    },
    'kime-tachiai-tsuki-age-2': {
      text: '受右腳前進，嘗試以上勾拳打下巴，發出氣合。',
    },
    'kime-tachiai-tsuki-age-3': {
      text: '取後仰，以雙手握手腕向上及斜前方拉，以站姿施腕挫腋固。',
    },
    'kime-tachiai-tsuki-age-4': {
      text: '受不應過度彎腰，應拍取的腿兩次表示認輸。',
    },
    'kime-tachiai-suri-age-1': {
      text: '相距約一步。',
    },
    'kime-tachiai-suri-age-2': {
      text: '受右腳前進，嘗試以右掌打取的前額，發出氣合。',
    },
    'kime-tachiai-suri-age-3': {
      text: '取後仰，以左前臂在肘部撥開攻擊，同時以右手反拳打腹部，發出氣合。',
    },
    'kime-tachiai-suri-age-4': {
      text: '隨即以左浮腰（Uki-goshi）摔出受。',
    },
    'kime-tachiai-yoko-uchi-1': {
      text: '相距約一步。',
    },
    'kime-tachiai-yoko-uchi-2': {
      text: '受右腳前進，嘗試以右拳打取的左太陽穴，發出氣合。',
    },
    'kime-tachiai-yoko-uchi-3': {
      text: '取左腳踏入潛避，推胸，握襟，依右腳、左腳順序踏至受後方。',
    },
    'kime-tachiai-yoko-uchi-4': {
      text: '送襟絞（Okuri-eri-jime）：前額抵住後腦，左腳後退並降低髖部。',
    },
    'kime-tachiai-yoko-uchi-5': {
      text: '受向下拉左上臂防守，以右腳擊榻榻米兩次表示認輸。',
    },
    'kime-tachiai-ke-age-1': {
      text: '距離：一步。',
    },
    'kime-tachiai-ke-age-2': {
      text: '受左腳向前一小步，嘗試踢腹股溝，發出氣合。',
    },
    'kime-tachiai-ke-age-3': {
      text: '取右腳後退，以體捌向右轉 90°，接住腳踝，將腳拉向左方，扭轉髖部踢腹股溝，發出氣合。',
    },
    'kime-tachiai-ke-age-4': {
      text: '雙方在遠間（約 1.2 米）相對。',
    },
    'kime-tachiai-ushiro-dori-1': {
      text: '受繞過取的右側，站在取的正後方約 90 厘米；同時取向後退。',
    },
    'kime-tachiai-ushiro-dori-2': {
      text: '取依左腳、右腳、左腳順序前進三步；第三步時，受環抱取的上臂。',
    },
    'kime-tachiai-ushiro-dori-3': {
      text: '取雙肘向外張，雙手握右袖上部，以背負投（Seoi-nage）摔出受。',
    },
    'kime-tachiai-ushiro-dori-4': {
      text: '取右膝著地、左膝立起，以手刀（Te-gatana）擊眉間，發出氣合；受在遠間（約 1.2 米）。',
    },
    'kime-tachiai-tsukkomi-1': {
      text: '受收取短刀，右手在上、左手在下，刃朝上放入上衣內。距離：約 90 厘米。',
    },
    'kime-tachiai-tsukkomi-2': {
      text: '受拔出短刀，左腳前進，嘗試刺心窩，發出氣合。',
    },
    'kime-tachiai-tsukkomi-3': {
      text: '取以體捌向右轉 90°，撥開攻擊，施當身，將手腕拉至髖部，握襟，斜向前移兩步，施腕挫腹固。',
    },
    'kime-tachiai-tsukkomi-4': {
      text: '受不應過度彎腰；應拍腿兩次，並將短刀放回上衣內。',
    },
    'kime-tachiai-kirikomi-1': {
      text: '受在約 90 厘米距離將短刀放在腰帶作為短劍；右腳前進，直劈前額，發出氣合。',
    },
    'kime-tachiai-kirikomi-2': {
      text: '取以雙手握手腕，將手臂夾於腋下，斜向後移並施腕挫腋固。',
    },
    'kime-tachiai-kirikomi-3': {
      text: '受不應過度彎腰；應拍腿兩次，回到遠間（約 1.2 米）；先將短劍放回腰帶，再作為短刀放回上衣內。',
    },
    'kime-tachiai-nuki-kake-1': {
      text: '受將短刀放回榻榻米，收取刀，刃朝上插於左側腰帶。',
    },
    'kime-tachiai-nuki-kake-2': {
      text: '在遠間，受右腳前進，嘗試拔刀。',
    },
    'kime-tachiai-nuki-kake-3': {
      text: '取右腳踏至受的右腳附近，右手控制右手腕，阻止拔刀。',
    },
    'kime-tachiai-nuki-kake-4': {
      text: '取左腳繞至受後方，握襟，斜向後退，施片羽絞（Kataha-jime）。',
    },
    'kime-tachiai-nuki-kake-5': {
      text: '受以右腳擊榻榻米兩次表示認輸。',
    },
    'kime-tachiai-kiri-oroshi-1': {
      text: '取與受的起始位置相距約 2.7 米。',
    },
    'kime-tachiai-kiri-oroshi-2': {
      text: '受緩慢拔刀，刀尖指向眼睛，採正眼（Seigan）架勢，以繼足前進一步；取從右腳起後退一步。',
    },
    'kime-tachiai-kiri-oroshi-3': {
      text: '受採上段（Jodan）架勢，嘗試劈頭頂，發出氣合；劈下前應先將刀立於頭上。',
    },
    'kime-tachiai-kiri-oroshi-4': {
      text: '取左腳前進，以體捌向右轉 90° 避撥，將手腕拉至髖部，握襟，依右、左、右斜向前進，施腕挫腹固。',
    },
    'kime-tachiai-kiri-oroshi-5': {
      text: '受不應過度彎腰；應拍腿兩次；完成收刀回位，取後退至原位。',
    },
  },
}
